<template>
  <div class="blog">
    <div class="wrapper container clearfix">
      <div class="posts">

        <div class="post">
          <div class="image" style="background-image: url('static/img/blog/post.jpg')">
            <div class="box">
              <div class="text">Excepteur sint occaecat cupidatat non proident</div>
              <div class="date">02.05.2017</div>
            </div>
          </div>
          <div class="post-text">
            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam
              rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt
              explicabo. Nemo enim ipsam
              voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui
              ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,
              consectetur, adipisci velit,
              sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut
              enim ad minima veniam, quis nostrum </p>
            <div class="read-more">
              <a href="#">Czytaj więcej</a>
            </div>
          </div>
        </div>

        <div class="post">
          <div class="image" style="background-image: url('static/img/blog/post.jpg')">
            <div class="box">
              <div class="text">At vero eos et accusamus et iusto</div>
              <div class="date">02.05.2017</div>
            </div>
          </div>
          <div class="post-text">
            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam
              rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt
              explicabo. Nemo enim ipsam
              voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui
              ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,
              consectetur, adipisci velit,
              sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut
              enim ad minima veniam, quis nostrum </p>
            <div class="read-more">
              <a href="#">Czytaj więcej</a>
            </div>
          </div>
        </div>

      </div>
      <div class="other-posts">
        <div class="top-text">Pozostałe wpisy</div>
        <ul>
          <li>
            <div class="dot"></div>
            <a href="#">
              <div class="date">25.01.2017</div>
              <p>Nam libero tempore, cum soluta nobis.</p>
            </a>
          </li>
          <li>
            <div class="dot"></div>
            <a href="#">
              <div class="date">25.01.2017</div>
              <p>Nam libero tempore, cum soluta nobis.</p>
            </a>
          </li>
          <li>
            <div class="dot"></div>
            <a href="#">
              <div class="date">25.01.2017</div>
              <p>Nam libero tempore, cum soluta nobis.</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <footer-main/>
  </div>
</template>

<script>
  import store from '../store/store';
  import FooterMain from '../components/FooterMain';

  export default {
    name: 'blog',
    data() {
      return {}
    },
    mounted: function () {
      store.state.isBlog = true;
    },
    destroyed: function () {
      store.state.isBlog = false;
    },
    components: {
      FooterMain
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// Blog.vue?664f68c4